import React from 'react'

class Marker extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="marker">
        <div className="pulse" />
      </div>
    )
  }
}

export default Marker
